import Vue from "vue";
import { ShakenStorage } from "@/service/storage";

// ログイン、店舗設定、一覧検索条件、共通Socket接続は予約を切り替えても維持する。
const RETAINED_MODULES = [
  "Authentication", "Environment", "FunctionSetting",
  "GlobalValue", "ReservationSearchData", "Socket"
];

let reservationModuleNames: string[] = [];

// JSON化と異なりundefinedも保持し、ネストした初期値を実データと共有しない。
function copyState(value: any): any {
  if (Array.isArray(value)) { return value.map(copyState); }
  if (value && typeof value === "object") {
    const result: any = {};
    Object.keys(value).forEach(key => { result[key] = copyState(value[key]); });
    return result;
  }
  return value;
}

/** Vuex登録前に一度だけ呼ぶ。clearStateを全予約モジュールで同じ契約にする。 */
export function prepareReservationModules(modules: any): void {
  reservationModuleNames = Object.keys(modules).filter(name => !RETAINED_MODULES.includes(name));
  reservationModuleNames.forEach(name => {
    const module = modules[name];
    const initial = copyState(typeof module.state === "function" ? module.state() : module.state || {});
    const originalClear = module.mutations && module.mutations.clearState;
    module.state = copyState(initial);
    module.mutations = {
      ...module.mutations,
      clearState(state: any) {
        // ReservationDetailのsessionStorage削除など既存の副作用も維持する。
        if (originalClear) { originalClear(state); }
        Object.keys(state).forEach(key => { Vue.delete(state, key); });
        const fresh = copyState(initial);
        Object.keys(fresh).forEach(key => { Vue.set(state, key, fresh[key]); });
      }
    };
    module.actions = {
      ...module.actions,
      clearState({ commit }: any) { commit("clearState"); }
    };
  });
}

// 顧客詳細で別の予約を開く際に、VuexとsessionStorageの予約データをクリアする。
export function clearReservationData({ commit }: any): void {
  reservationModuleNames.forEach(name => commit(name + "/clearState"));
  ShakenStorage.removeReservationSessionData();
}
